import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ce77aca"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "area",
  class: "modal-size box-border px-12 bg-gray-300 dark:bg-dark-900",
  style: {"position":"relative"}
}
const _hoisted_2 = { class: "h-full flex justify-center items-center" }
const _hoisted_3 = {
  key: 1,
  class: "modal-size box-border grid bg-gray-300 dark:bg-dark-900",
  style: {"user-select":"none"}
}
const _hoisted_4 = { class: "w-full p-8 grid grid-rows-2 gap-6" }
const _hoisted_5 = { class: "grid grid-cols-4 row-span-1 gap-6" }
const _hoisted_6 = { class: "grid col-span-1" }
const _hoisted_7 = { class: "grid gap-4 grid-cols-2 grid-rows-2" }
const _hoisted_8 = { class: "w-full h-full col-span-3 grid grid-cols-3 gap-6" }
const _hoisted_9 = {
  class: "grid p-2 bg-white dark:bg-dark-400",
  style: {"border-radius":"1rem"}
}
const _hoisted_10 = {
  class: "grid h-full p-2 bg-white dark:bg-dark-400",
  style: {"border-radius":"1rem"}
}
const _hoisted_11 = {
  class: "grid p-2 bg-white dark:bg-dark-400",
  style: {"border-radius":"1rem"}
}
const _hoisted_12 = { class: "grid grid-cols-3 row-span-1 gap-6" }
const _hoisted_13 = {
  class: "grid col-span-2 shadow-md p-4 bg-white dark:bg-dark-400",
  style: {"border-radius":"1rem"}
}
const _hoisted_14 = {
  class: "grid col-span-1 p-4 bg-white dark:bg-dark-400",
  style: {"border-radius":"1rem"}
}
const _hoisted_15 = {
  key: 2,
  class: "modal-size box-border grid bg-gray-300 dark:bg-dark-900",
  style: {"user-select":"none"}
}
const _hoisted_16 = { class: "w-full p-8 grid grid-rows-2 gap-6" }
const _hoisted_17 = {
  class: "grid col-span-1 bg-white dark:bg-dark-400",
  style: {"border-radius":"1rem"}
}
const _hoisted_18 = {
  class: "bg-white dark:bg-dark-400",
  style: {"border-radius":"1rem"}
}
const _hoisted_19 = { class: "grid grid-cols-3 row-span-1 gap-6" }
const _hoisted_20 = {
  class: "shadow-md p-3 bg-white dark:bg-dark-400",
  style: {"border-radius":"1rem"}
}
const _hoisted_21 = {
  class: "shadow-md p-3 bg-white dark:bg-dark-400",
  style: {"border-radius":"1rem"}
}
const _hoisted_22 = {
  class: "shadow-md p-3 bg-white dark:bg-dark-400",
  style: {"border-radius":"1rem"}
}
const _hoisted_23 = { key: 3 }
const _hoisted_24 = {
  class: "course-modal-size box-border grid bg-gray-300 dark:bg-dark-900",
  style: {"user-select":"none"}
}
const _hoisted_25 = { class: "w-full p-8 grid gap-6" }
const _hoisted_26 = {
  class: "grid col-span-1 bg-white dark:bg-dark-400",
  style: {"border-radius":"1rem"}
}
const _hoisted_27 = {
  class: "bg-white dark:bg-dark-400 shadow-md",
  style: {"border-radius":"1rem"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardHeader = _resolveComponent("DashboardHeader")!
  const _component_LoadingPanel = _resolveComponent("LoadingPanel")!
  const _component_StatusCard = _resolveComponent("StatusCard")!
  const _component_ProgrammingCategoryRatingsChart = _resolveComponent("ProgrammingCategoryRatingsChart")!
  const _component_WhatCategoryRatingsChart = _resolveComponent("WhatCategoryRatingsChart")!
  const _component_HowCategoryRatingsChart = _resolveComponent("HowCategoryRatingsChart")!
  const _component_LanguageStatisticsChart = _resolveComponent("LanguageStatisticsChart")!
  const _component_SubmissionStatusChart = _resolveComponent("SubmissionStatusChart")!
  const _component_HeatMap = _resolveComponent("HeatMap")!
  const _component_DailyEffortsChart = _resolveComponent("DailyEffortsChart")!
  const _component_SolvedProblemsChart = _resolveComponent("SolvedProblemsChart")!
  const _component_WeeklyRatingChart = _resolveComponent("WeeklyRatingChart")!
  const _component_CourseHeader = _resolveComponent("CourseHeader")!
  const _component_CourseHeatMap = _resolveComponent("CourseHeatMap")!
  const _component_PrimaryModal = _resolveComponent("PrimaryModal")!

  return (_openBlock(), _createBlock(_component_PrimaryModal, {
    onClickBackground: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_DashboardHeader, {
        initDashboardUser: _ctx.initialDashboardUser,
        onChangeProgramLanguage: _ctx.changeProgramLanguage
      }, null, 8, ["initDashboardUser", "onChangeProgramLanguage"]),
      (_ctx.dashboardModalStatePresenter.isAddingDashboardUser.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_LoadingPanel)
            ])
          ]))
        : (_ctx.dashboardModalStatePresenter.tabState.value == 'OVERVIEW')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_StatusCard, {
                        fontSize: 'text-3xl',
                        label: _ctx.$t('message.submission').toString(),
                        value: _ctx.initialDashboardUser.status != null ? _ctx.initialDashboardUser.status.submissions.toString() : '0'
                      }, null, 8, ["label", "value"]),
                      _createVNode(_component_StatusCard, {
                        fontSize: 'text-3xl',
                        label: _ctx.$t('message.solvedProblem').toString(),
                        value: _ctx.initialDashboardUser.status != null ? _ctx.initialDashboardUser.status.solved.toString() : '0'
                      }, null, 8, ["label", "value"]),
                      (_ctx.weeklyRatingPresenter.userWeeklyRatingList.value[0].length > 0)
                        ? (_openBlock(), _createBlock(_component_StatusCard, {
                            key: 0,
                            fontSize: 'text-3xl',
                            label: _ctx.$t('message.rating').toString(),
                            value: 
                  _ctx.weeklyRatingPresenter.userWeeklyRatingList.value[0][
                    _ctx.weeklyRatingPresenter.userWeeklyRatingList.value[0].length - 1
                  ].rating
                    .toFixed(2)
                    .toString()
                
                          }, null, 8, ["label", "value"]))
                        : _createCommentVNode("", true),
                      (!(_ctx.weeklyRatingPresenter.userWeeklyRatingList.value[0].length > 0))
                        ? (_openBlock(), _createBlock(_component_StatusCard, {
                            key: 1,
                            fontSize: 'text-3xl',
                            label: _ctx.$t('message.rating').toString(),
                            value: '0.00'
                          }, null, 8, ["label"]))
                        : _createCommentVNode("", true),
                      (_ctx.initialDashboardUser.lastSubmitDate.toLocaleString() == _ctx.BEGIN_DATE)
                        ? (_openBlock(), _createBlock(_component_StatusCard, {
                            key: 2,
                            fontSize: 'text-3xl',
                            label: _ctx.$t('message.lastSubmitDate').toString(),
                            value: '---'
                          }, null, 8, ["label"]))
                        : _createCommentVNode("", true),
                      (_ctx.initialDashboardUser.lastSubmitDate.toLocaleString() != _ctx.BEGIN_DATE)
                        ? (_openBlock(), _createBlock(_component_StatusCard, {
                            key: 3,
                            fontSize: 'text-lg',
                            label: _ctx.$t('message.lastSubmitDate').toString(),
                            value: 
                  _ctx.initialDashboardUser.lastSubmitDate != null
                    ? _ctx.initialDashboardUser.lastSubmitDate.toLocaleString()
                    : '---'
                
                          }, null, 8, ["label", "value"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_ProgrammingCategoryRatingsChart)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_WhatCategoryRatingsChart)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_HowCategoryRatingsChart)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_LanguageStatisticsChart)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_SubmissionStatusChart)
                  ])
                ])
              ])
            ]))
          : (_ctx.dashboardModalStatePresenter.tabState.value == 'DAILY')
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_HeatMap)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_DailyEffortsChart)
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_SolvedProblemsChart)
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_WeeklyRatingChart)
                    ])
                  ])
                ])
              ]))
            : (_ctx.dashboardModalStatePresenter.tabState.value == 'COURSE')
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createVNode(_component_CourseHeader),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _createVNode(_component_CourseHeatMap, {
                            course: _ctx.currentCourse,
                            programLanguage: _ctx.courseProgramLanguage,
                            user: _ctx.initialDashboardUser
                          }, null, 8, ["course", "programLanguage", "user"])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}